<template>
  <div class="mvxq-page">
    <div class="mvxq-page__back" @click="goBack">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M19 12H5"></path>
        <path d="M12 19l-7-7 7-7"></path>
      </svg>
      <span>返回</span>
    </div>

    <div class="mvxq-page__main">
      <div class="mvxq-page__player-card">
        <div class="mvxq-page__video-wrap" @mouseenter="isMouseOverVideo = true" @mouseleave="isMouseOverVideo = false">
          <video 
            ref="videoPlayer" 
            :src="mvData.url" 
            :poster="mvData.image"
            class="mvxq-page__video"
            @timeupdate="updateProgress"
            @loadedmetadata="onVideoLoaded"
            @ended="onVideoEnded"
            @play="onVideoPlay"
            @pause="onVideoPause"
            @click="togglePlay"
            playsinline
          ></video>
          <div class="mvxq-page__play-btn" v-show="!isPlaying || isMouseOverVideo" @click.stop="togglePlay">
            <svg v-if="!isPlaying" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="6" y="4" width="4" height="16"></rect>
              <rect x="14" y="4" width="4" height="16"></rect>
            </svg>
          </div>
          <div class="mvxq-page__time-display">
            <span>{{ formatTime(currentTime) }}</span>
            <span>{{ formatTime(duration) }}</span>
          </div>
          <div class="mvxq-page__progress-bar" @click="seekTo" @mousedown="startDragProgress" @touchstart="startDragProgress">
            <div class="mvxq-page__progress-fill" :style="{ width: progressPercent + '%' }"></div>
            <div class="mvxq-page__progress-thumb" :style="{ left: progressPercent + '%' }"></div>
            <!-- VIP限制节点：非VIP用户看VIP视频时显示30秒节点 -->
            <div 
              v-if="shouldShowVipNode" 
              class="mvxq-page__vip-node"
              :style="{ left: vipNodePercent + '%' }"
              title="试看结束"
            ></div>
          </div>
          <div class="mvxq-page__controls">
            <button class="mvxq-page__ctrl-btn" @click="togglePlay">
              <svg v-if="!isPlaying" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="6" y="4" width="4" height="16"></rect>
                <rect x="14" y="4" width="4" height="16"></rect>
              </svg>
            </button>
            <div class="mvxq-page__volume-control">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
              </svg>
              <div class="mvxq-page__volume-bar" @click="setVolume" @mousedown="startDragVolume" @touchstart="startDragVolume">
                <div class="mvxq-page__volume-fill" :style="{ width: volume + '%' }"></div>
              </div>
            </div>
            <button class="mvxq-page__ctrl-btn" @click="toggleFullscreen">
              <svg v-if="!isFullscreen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 8h16M4 16h16"></path>
                <rect x="2" y="4" width="20" height="16"></rect>
              </svg>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M8 4H4m0 0v4M4 4l4-4m12 4l4 4m0-4v4m0 12h4m0 0v-4m0-4l-4 4"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="mvxq-page__info-card">
        <div class="mvxq-page__header">
          <h1 class="mvxq-page__title">{{ mvData.title }} 
            <span v-if="mvData.isnovip == 1" class="vip-badge">VIP</span>
          </h1>
          <p class="mvxq-page__artist">{{ mvData.author }}</p>
        </div>
        <div class="mvxq-page__actions">
          <button class="mvxq-page__action-btn" :class="{ 'mvxq-page__action-btn--liked': isLiked }" @click="toggleLike">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
            <span>{{ isLiked ? '已收藏' : '收藏' }}</span>
          </button>
          <button class="mvxq-page__action-btn" @click="fenxiang">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
            </svg>
            <span>分享</span>
          </button>
        </div>
        <div class="mvxq-page__stats">
          <span>{{ formatNumber(mvData.bofang) }} 播放</span>
          <span>{{ formatNumber(mvData.zan) }} 喜欢</span>
        </div>
      </div>

      <div class="mvxq-page__related">
        <h2 class="mvxq-page__related-title">相关推荐</h2>
        <div class="mvxq-page__related-grid">
          <div
            v-for="mv in relatedMvs"
            :key="mv.id"
            class="mvxq-page__related-item"
            @click="goToMv(mv)"
          >
            <div class="mvxq-page__related-thumb">
              <img :src="mv.image" :alt="mv.title" />
            </div>
            <div class="mvxq-page__related-info">
              <h4 class="mvxq-page__related-name">{{ mv.title }}</h4>
              <p class="mvxq-page__related-artist">{{ mv.author }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vip-modal" v-if="isVipModalVisible" @click.self="closeVipModal">
      <div class="vip-modal__inner">
        <div class="vip-modal__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="#f37021" stroke-width="2">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"></path>
          </svg>
        </div>
        <h3 class="vip-modal__title">VIP专属内容</h3>
        <p class="vip-modal__desc">该MV为VIP内容，请开通VIP后畅看完整内容</p>
        <div class="vip-modal__btn-group">
          <button class="vip-modal__btn vip-modal__btn--cancel" @click="closeVipModal">关闭</button>
          <button class="vip-modal__btn vip-modal__btn--vip" @click="goToVip">开通VIP</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'MvXq',
  data() {
    return {
      isPlaying: false,
      isLiked: false,
      isFullscreen: false,
      isMouseOverVideo: false,
      isDraggingProgress: false,
      isDraggingVolume: false,
      hasShownVipModal: false,
      isVipModalVisible: false,
      currentTime: 0,
      duration: 0,
      volume: 80,
      mvData: {
        id: '',
        title: '',
        author: '',
        url: '',
        content: '',
        image: '',
        pingfen: '',
        bofang: '',
        zan: ''
      },
      relatedMvs: []
    }
  },
  computed: {
    progressPercent() {
      return this.duration > 0 ? (this.currentTime / this.duration) * 100 : 0
    },
    // 是否显示VIP节点：VIP歌曲 && (用户未登录 || 用户非VIP)
    shouldShowVipNode() {
      return this.mvData.isnovip == 1 && !this.hasVipAccess()
    },
    // VIP节点位置（30秒处）
    vipNodePercent() {
      return this.duration > 0 ? (30 / this.duration) * 100 : 0
    }
  },
  mounted() {
    const audio = this.$parent.$refs.audioPlayer
    if (audio && !audio.paused) {
      audio.pause()
      this.$store.commit('setPlaying', false)
    }
    
    const id = this.$route.query.id
    if (id) {
      this.loadMvDetail(id)
    }
    document.addEventListener('fullscreenchange', this.onFullscreenChange)
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange)
  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange)
    document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange)
    this.pauseVideo()
  },
  watch: {
    '$route.query.id'(newId) {
      if (newId) {
        this.loadMvDetail(newId)
      }
    }
  },
  methods: {
    // 分享功能 - 复制链接到剪切板
    fenxiang() {
      const currentUrl = window.location.href;
      // 复制链接到剪切板
      if (navigator.clipboard) {
        navigator.clipboard.writeText(currentUrl).then(() => {
          alert('链接已复制到剪切板');
        }).catch(() => {
          // 降级方案
          this.copyTextFallback(currentUrl);
        });
      } else {
        // 降级方案
        this.copyTextFallback(currentUrl);
      }
    },
    // 复制文本降级方案
    copyTextFallback(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        alert('链接已复制到剪切板');
      } catch (err) {
        alert('复制失败，请手动复制链接');
      }
      document.body.removeChild(textarea);
    },
    /**
     * 加载MV详情
     * @param {number} id - MV ID
     */
    loadMvDetail(id) {
      const username =  localStorage.getItem('YousrDL') ? JSON.parse(localStorage.getItem('YousrDL')).username : null

      axios.get('https://xinyinyue.xiangyouhulian.cn/api/index/mvdetail', { params: { id, username } })
        .then(response => {
          const data = response.data
          if (data.data) {
            this.mvData = data.data.detail || data.data || {}
            this.relatedMvs = data.data.rand_list || []
            this.currentTime = 0
            this.duration = 0
            this.isPlaying = false
            this.hasShownVipModal = false
            this.isLiked = this.mvData.status == 1
          }
        })
        .catch(error => {
          console.error('获取MV详情失败:', error)
        })
    },
    
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.push('/mv')
    },
    
    /**
     * 播放/暂停切换
     */
    togglePlay() {
      const video = this.$refs.videoPlayer
      if (!video) return

      if (this.mvData.isnovip == 1 && !this.hasVipAccess()) {
        if (video.currentTime >= 30) {
          video.currentTime = 30
          this.isVipModalVisible = true
          return
        }
      }
      
      if (this.isPlaying) {
        video.pause()
      } else {
        video.play().catch(e => {
          console.error('播放失败:', e)
        })
      }
    },
    
    /**
     * 暂停视频
     */
    pauseVideo() {
      const video = this.$refs.videoPlayer
      if (video) {
        video.pause()
      }
    },
    
    /**
     * 更新播放进度
     */
    updateProgress() {
      const video = this.$refs.videoPlayer
      if (!video) return
      
      this.currentTime = Math.floor(video.currentTime)
      this.duration = Math.floor(video.duration)

      this.checkVipLimit(video)
    },

    checkVipLimit(video) {
      if (!video || !this.mvData.isnovip || this.mvData.isnovip != 1) return

      if (this.hasVipAccess()) return

      if (video.currentTime >= 30) {
        video.pause()
        if (!this.hasShownVipModal) {
          this.hasShownVipModal = true
          this.isVipModalVisible = true
        }
      }
    },

    onVideoPlay() {
      this.isPlaying = true
      const video = this.$refs.videoPlayer
      if (video && this.mvData.isnovip == 1 && !this.hasVipAccess()) {
        if (video.currentTime >= 30) {
          video.pause()
          this.isPlaying = false
          this.isVipModalVisible = true
        }
      }
    },

    onVideoPause() {
      this.isPlaying = false
    },

    closeVipModal() {
      this.isVipModalVisible = false
    },

    goToVip() {
      this.isVipModalVisible = false
      this.$router.push('/vip')
    },

    hasVipAccess() {
      const savedUser = localStorage.getItem('YousrDL')
      if (!savedUser) return false

      const userInfo = JSON.parse(savedUser)
      if (!userInfo) return false

      if (Array.isArray(userInfo)) {
        return userInfo.length > 0 && userInfo[0].isnovip == 1
      }
      return userInfo.isnovip == 1
    },
    
    /**
     * 视频加载完成
     */
    onVideoLoaded() {
      const video = this.$refs.videoPlayer
      if (!video) return
      
      this.duration = Math.floor(video.duration)
    },
    
    /**
     * 视频播放结束
     */
    onVideoEnded() {
      this.isPlaying = false
      this.currentTime = 0
    },
    
    /**
     * 进度条点击跳转
     * @param {Event} e - 点击事件
     */
    seekTo(e) {
      if (this.isDraggingProgress) return
      const video = this.$refs.videoPlayer
      if (!video || !video.duration) return
      
      const rect = e.currentTarget.getBoundingClientRect()
      const percent = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100))
      let targetTime = (percent / 100) * video.duration
      
      if (this.mvData.isnovip == 1 && !this.hasVipAccess() && targetTime > 30) {
        targetTime = 30
      }
      
      video.currentTime = targetTime
      this.currentTime = Math.floor(targetTime)
    },
    
    /**
     * 开始拖拽进度条
     * @param {Event} e - 鼠标按下事件
     */
    startDragProgress(e) {
      this.isDraggingProgress = true
      const video = this.$refs.videoPlayer
      if (video) {
        video.pause()
      }
      
      const moveHandler = (ev) => {
        if (!this.isDraggingProgress) return
        
        const rect = document.querySelector('.mvxq-page__progress-bar').getBoundingClientRect()
        const clientX = ev.touches ? ev.touches[0].clientX : ev.clientX
        const percent = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100))
        this.currentTime = Math.floor((percent / 100) * (video ? video.duration : this.duration))
      }
      
      const upHandler = () => {
        this.isDraggingProgress = false
        document.removeEventListener('mousemove', moveHandler)
        document.removeEventListener('mouseup', upHandler)
        document.removeEventListener('touchmove', moveHandler)
        document.removeEventListener('touchend', upHandler)
        
        if (video && video.duration) {
          video.currentTime = this.currentTime
          video.play().catch(() => {})
        }
      }
      
      document.addEventListener('mousemove', moveHandler)
      document.addEventListener('mouseup', upHandler)
      document.addEventListener('touchmove', moveHandler, { passive: false })
      document.addEventListener('touchend', upHandler)
      
      moveHandler(e)
    },
    
    /**
     * 设置音量
     * @param {Event} e - 点击事件
     */
    setVolume(e) {
      if (this.isDraggingVolume) return
      const video = this.$refs.videoPlayer
      if (!video) return
      
      const rect = e.currentTarget.getBoundingClientRect()
      const percent = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100))
      this.volume = percent
      video.volume = percent / 100
    },
    
    /**
     * 开始拖拽音量条
     * @param {Event} e - 鼠标按下事件
     */
    startDragVolume(e) {
      this.isDraggingVolume = true
      const video = this.$refs.videoPlayer
      
      const moveHandler = (ev) => {
        if (!this.isDraggingVolume) return
        
        const rect = document.querySelector('.mvxq-page__volume-bar').getBoundingClientRect()
        const clientX = ev.touches ? ev.touches[0].clientX : ev.clientX
        const percent = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100))
        this.volume = percent
        if (video) {
          video.volume = percent / 100
        }
      }
      
      const upHandler = () => {
        this.isDraggingVolume = false
        document.removeEventListener('mousemove', moveHandler)
        document.removeEventListener('mouseup', upHandler)
        document.removeEventListener('touchmove', moveHandler)
        document.removeEventListener('touchend', upHandler)
      }
      
      document.addEventListener('mousemove', moveHandler)
      document.addEventListener('mouseup', upHandler)
      document.addEventListener('touchmove', moveHandler, { passive: false })
      document.addEventListener('touchend', upHandler)
      
      moveHandler(e)
    },
    
    /**
     * 全屏切换
     */
    toggleFullscreen() {
      const video = this.$refs.videoPlayer
      if (!video) return
      
      if (this.isFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
      } else {
        if (video.requestFullscreen) {
          video.requestFullscreen()
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen()
        }
      }
    },
    
    /**
     * 全屏状态改变
     */
    onFullscreenChange() {
      this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement)
    },
    
    /**
     * 喜欢/取消喜欢
     */
    toggleLike() {
      const savedUser = localStorage.getItem('YousrDL')
      if (!savedUser) {
        alert('你还没有登录！')
        return
      }

      const userInfo = JSON.parse(savedUser)
      if (!userInfo) {
        alert('获取用户信息失败')
        return
      }

      const username = userInfo.username || ''
      if (!username) {
        alert('获取用户信息失败')
        return
      }

      const mvid = this.mvData.id
      if (!mvid) {
        alert('请先选择一首MV')
        return
      }

      const currentStatus = this.mvData.status == 1 ? 0 : 1

      axios.get('https://xinyinyue.xiangyouhulian.cn/api/index/mvshoucang', {
        params: {
          username: username,
          mvid: mvid,
          status: currentStatus
        }
      })
      .then(response => {
        if (response.data.code === 1) {
          this.mvData.status = currentStatus
          this.isLiked = currentStatus == 1
          alert(currentStatus === 1 ? '收藏成功' : '取消收藏成功')
        } else {
          alert(response.data.msg || '操作失败')
        }
      })
      .catch(error => {
        console.error('收藏失败:', error)
        alert('收藏失败，请稍后重试')
      })
    },
    
    /**
     * 跳转到相关MV
     * @param {Object} mv - MV数据
     */
    goToMv(mv) {
      this.$router.push({ path: '/mvxq', query: { id: mv.id } })
    },
    
    /**
     * 格式化时间
     * @param {number} seconds - 秒数
     * @returns {string} 格式化后的时间
     */
    formatTime(seconds) {
      if (!seconds || seconds < 0) return '0:00'
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins}:${secs.toString().padStart(2, '0')}`
    },
    
    /**
     * 格式化数字
     * @param {number} num - 数字
     * @returns {string} 格式化后的数字
     */
    formatNumber(num) {
      const n = parseInt(num)
      if (isNaN(n)) return '0'
      if (n >= 10000) {
        return (n / 10000).toFixed(1) + '万'
      }
      return n.toString()
    }
  }
}
</script>

<style scoped lang="scss">
.vip-badge{
  font-size: 12px;
  font-weight: normal;
  color: #f37021;
  padding: 4px 6px;
  border: 1px solid #f37021;
  margin-left: 10px;
}
.mvxq-page {
  width: 100%;
  min-height: 100vh;
  font-family: Arial, Helvetica, sans-serif;
  padding: 30px 20px 40px 20px;
  box-sizing: border-box;
  background-image: url('../../assets/hoem.jpg');
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-color: #1a1a1a;

  &__back {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    margin-bottom: 25px;
    transition: opacity 0.2s ease;

    svg {
      width: 18px;
      height: 18px;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  &__main {
    max-width: 900px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__player-card {
    background-color: rgba(0, 0, 0, 0.65);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
  }

  &__video-wrap {
    position: relative;
    width: 100%;
  }

  &__video {
    width: 100%;
    display: block;
    aspect-ratio: 16/9;
    object-fit: cover;
  }

  &__play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 76px;
    height: 76px;
    background-color: rgba(154, 31, 19, 0.95);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 6px 24px rgba(154, 31, 19, 0.5);

    svg {
      width: 30px;
      height: 30px;
      margin-left: 4px;
    }

    &:hover {
      transform: translate(-50%, -50%) scale(1.1);
      background-color: rgba(138, 26, 18, 1);
    }
  }

  &__progress-bar {
    position: absolute;
    bottom: 65px;
    left: 20px;
    right: 20px;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
    cursor: pointer;

    &:hover {
      height: 6px;
    }
  }

  &__progress-fill {
    height: 100%;
    background-color: #9a1f13;
    border-radius: 2px;
  }

  &__progress-thumb {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 14px;
    height: 14px;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
    opacity: 0;
    transition: opacity 0.2s ease;

    .mvxq-page__progress-bar:hover & {
      opacity: 1;
    }
  }

  // VIP试看节点标记
  &__vip-node {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 3px;
    height: 10px;
    background-color: #ff4444;
    border-radius: 1px;
    cursor: pointer;
    z-index: 5;
  }

  &__time-display {
    position: absolute;
    bottom: 85px;
    left: 20px;
    right: 20px;
    display: flex;
    justify-content: space-between;
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }

  &__controls {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 20px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.85), transparent);
  }

  &__ctrl-btn {
    background: none;
    border: none;
    color: #ffffff;
    cursor: pointer;
    padding: 6px;
    transition: opacity 0.2s ease;

    svg {
      width: 20px;
      height: 20px;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  &__volume-control {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;

    svg {
      width: 18px;
      height: 18px;
      color: #ffffff;
    }
  }

  &__volume-bar {
    width: 60px;
    height: 3px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
    cursor: pointer;
  }

  &__volume-fill {
    height: 100%;
    background-color: #9a1f13;
    border-radius: 2px;
  }

  &__info-card {
    background-color: rgba(87, 28, 28, 0.85);
    border-radius: 14px;
    padding: 24px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(12px);
  }

  &__header {
    margin-bottom: 18px;
  }

  &__title {
    font-size: 22px;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 8px 0;
    line-height: 1.4;
  }

  &__artist {
    font-size: 15px;
    color: #ffcc80;
    font-weight: 500;
    margin: 0;
  }

  &__actions {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
  }

  &__action-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    padding: 9px 16px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.25s ease;

    svg {
      width: 16px;
      height: 16px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      border-color: #ffcc80;
      color: #ffffff;
    }

    &--liked {
      background-color: rgba(154, 31, 19, 0.4);
      border-color: #ffcc80;
      color: #ffcc80;
    }
  }

  &__stats {
    display: flex;
    gap: 20px;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
  }

  &__related {
    background-color: rgba(87, 28, 28, 0.85);
    border-radius: 14px;
    padding: 24px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(12px);
  }

  &__related-title {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 20px 0;
  }

  &__related-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 16px;
  }

  &__related-item {
    display: flex;
    gap: 12px;
    cursor: pointer;
    padding: 10px;
    border-radius: 10px;
    transition: all 0.25s ease;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  &__related-thumb {
    position: relative;
    width: 110px;
    height: 62px;
    flex-shrink: 0;
    border-radius: 6px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__related-duration {
    position: absolute;
    bottom: 4px;
    right: 4px;
    padding: 2px 6px;
    background-color: rgba(0, 0, 0, 0.75);
    border-radius: 3px;
    color: #ffffff;
    font-size: 10px;
    font-weight: 500;
  }

  &__related-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
  }

  &__related-name {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 4px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__related-artist {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    margin: 0;
  }

  @media (max-width: 768px) {
    padding: 20px 15px 120px 15px;

    &__back {
      margin-bottom: 18px;
    }

    &__play-btn {
      width: 56px;
      height: 56px;

      svg {
        width: 24px;
        height: 24px;
      }
    }

    &__progress-bar {
      bottom: 55px;
      left: 15px;
      right: 15px;
    }

    &__time-display {
      bottom: 22px;
      left: 15px;
      right: 15px;
    }

    &__controls {
      gap: 10px;
      padding: 12px 15px;
    }

    &__volume-control {
      display: none;
    }

    &__info-card {
      padding: 20px;
    }

    &__title {
      font-size: 20px;
    }

    &__actions {
      gap: 12px;
    }

    &__action-btn {
      padding: 7px 12px;
      font-size: 12px;
    }

    &__related-grid {
      grid-template-columns: 1fr;
    }

    &__related-item {
      padding: 8px;
    }

    &__related-thumb {
      width: 100px;
      height: 56px;
    }
  }
}

.vip-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;

  &__inner {
    background: linear-gradient(135deg, #5c3538 0%, #4a282b 100%);
    border-radius: 12px;
    padding: 30px 40px;
    text-align: center;
    min-width: 320px;
    animation: scaleIn 0.2s ease-out;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__icon {
    width: 60px;
    height: 60px;
    margin: 0 auto 15px;
    background-color: rgba(243, 112, 33, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 32px;
      height: 32px;
    }
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 8px 0;
  }

  &__desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 25px 0;
    line-height: 1.5;
  }

  &__btn-group {
    display: flex;
    gap: 12px;
    justify-content: center;
  }

  &__btn {
    padding: 10px 24px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    text-decoration: none;
    display: inline-block;

    &--cancel {
      background-color: transparent;
      color: rgba(255, 255, 255, 0.7);
      border: 1px solid rgba(255, 255, 255, 0.3);

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }

    &--vip {
      background-color: #f37021;
      color: #ffffff;

      &:hover {
        background-color: #d95e12;
      }
    }
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
</style>